import { IPublicClientApplication } from "@azure/msal-browser";

export default class PublicClientApplicationHolder {
  private static INSTANCE: IPublicClientApplication | null = null;

  public static storeInstance(application: IPublicClientApplication): IPublicClientApplication {
    PublicClientApplicationHolder.INSTANCE = application;
    return application;
  }

  public static getInstance() {
    return PublicClientApplicationHolder.INSTANCE;
  }
}
